import(/* webpackMode: "eager" */ "/vercel/path0/src/app/talent/page.tsx");
